import RenderManager from "../rendering/render-manager";

const awaitLib = (function () {
    let promise;
    return function () {
        return promise = (promise || new Promise(resolve => {
            console.warn("Q3: Nexus not initialized. Begun downloading.");
            injectJS("/js/nexus.libs.base.js").then(function () {
                console.info("Q3: Nexus downloaded.");
                resolve();
            });
        }));
    };
})();


class NexusMesh extends THREE.Object3D {
    constructor(geometry, material) {
        super();

        this.type = "NexusMesh";

        const onLoad = () => { };
        const onUpdate = () => { };

        this._nexusObject = {
            geometry,
            material
        };

        awaitLib().then(() => {
            let nexus = new NexusObject({
                url: Q3.s3Url + geometry,
                onLoad,
                onUpdate,
                renderer: RenderManager.mainRenderer,
                material
            });
            nexus.dontShowInHierarchyPanel = true;

            this.add(nexus);
        });
    }

    get nexusObject() { return this._nexusObject; }
}

export default NexusMesh;
export { NexusMesh };